export default __webpack_public_path__ + "static/media/Jam-Matkul.e570ff98.svg";